export default __webpack_public_path__ + "static/app_store_badge_en-610fcad044808bcf0dc426468ecddcf5.svg";